module.exports = __webpack_public_path__ + "static/img/sdfsdfds.5b82783.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/sdfsdfds.png
// module id = 1160
// module chunks = 36